import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { cn } from '../../../common-utils/libraries/tailwind/utils'; // Replace with your utility for class concatenation
import PropTypes from 'prop-types';

const ScrollArea = ({ children, className, ...props }) => {
    return (
        <ScrollAreaPrimitive.Root
            className={cn('relative overflow-hidden', className)}
            {...props}
        >
            <ScrollAreaPrimitive.Viewport className='h-full w-full rounded p-2'>
                {children}
            </ScrollAreaPrimitive.Viewport>
            <ScrollAreaPrimitive.Scrollbar
                orientation='vertical'
                className='flex touch-none select-none p-0.5 bg-gray-300 transition-colors'
            >
                <ScrollAreaPrimitive.Thumb className='flex-1 rounded min-w-2 min-h-[12px] bg-gray-400 transition-colors' />
            </ScrollAreaPrimitive.Scrollbar>
            <ScrollAreaPrimitive.Scrollbar
                orientation='horizontal'
                className='flex touch-none select-none p-0.5 bg-gray-600 transition-colors'
            >
                <ScrollAreaPrimitive.Thumb className='flex-1 rounded bg-gray-400 transition-colors' />
            </ScrollAreaPrimitive.Scrollbar>
            <ScrollAreaPrimitive.Corner className='bg-gray-200' />
        </ScrollAreaPrimitive.Root>
    );
};

ScrollArea.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default ScrollArea;

